import { render, staticRenderFns } from "./BatchTypes.template.vue?vue&type=template&id=fff49894&scoped=true&"
var script = {}
import style0 from "./BatchTypes.template.vue?vue&type=style&index=0&id=fff49894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff49894",
  null
  
)

export default component.exports